module.exports = __webpack_public_path__ + "img/consultoria_9-16_1080.2919ec69.webp";